var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "mb-2 col-md-6" },
        [
          _c(
            "el-select",
            {
              staticClass: "w-100",
              attrs: {
                multiple: _vm.multiple,
                clearable: _vm.clearable,
                value: _vm.pending,
                placeholder: _vm.placeholder,
                filterable: "",
                remote: "",
                "remote-method": _vm.searchOptions,
              },
              on: { change: _vm.onChange },
            },
            _vm._l(_vm.options, function (option) {
              return _c("el-option", {
                key: option[_vm.optionKey],
                attrs: {
                  label: option[_vm.optionLabel],
                  value: option[_vm.optionValue],
                },
              })
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }